import { Client, ClientMock, RecursivePartial } from '@aiwyn/shared';
import { merge } from 'ts-deepmerge';

export interface AddOnOption {
  id: number;
  type: string;
  input: {
    type: AddOnInputType;
    label: string;
    hint: string;
  };
}

export enum AddOnInputType {
  INPUT = 'INPUT',
  TEXT_BOX = 'TEXT_BOX',
}

export interface AddOn {
  id: number;
  account: Client;
  type: string;
  name: string;
  notes: string;
  paymentAmount: string;
}

export interface AddOnWithFee extends AddOn {
  processingFee?: number;
  internationalFee?: number;
}

export class AddOnOptionMock {
  protected _model: AddOnOption = {
    id: 1,
    type: 'MISCELLANEOUS',
    input: {
      type: AddOnInputType.INPUT,
      label: 'label',
      hint: 'hint',
    },
  };

  constructor(overrides: RecursivePartial<AddOnOption> = {}) {
    this._model = merge.withOptions(
      { mergeArrays: false },
      this._model,
      overrides,
    ) as unknown as AddOnOption;
  }

  public model(): AddOnOption {
    return this._model;
  }
}

export class AddOnMock {
  protected _model: AddOn = {
    id: 1,
    account: new ClientMock().model(),
    type: 'MISCELLANEOUS',
    name: 'Miscellaneous',
    notes: 'notes',
    paymentAmount: '100.00',
  };

  constructor(overrides: RecursivePartial<AddOn> = {}) {
    this._model = merge.withOptions(
      { mergeArrays: false },
      this._model,
      overrides,
    ) as unknown as AddOn;
  }

  public model(): AddOn {
    return this._model;
  }
}
